/* eslint-disable no-param-reassign */
import produce from 'immer';
import { SET_ACTIVITY_COUNTS } from 'src/actions/activityActions';
import { LOGOUT } from 'src/actions/accountActions';

// CON-XXXX — activity badges. areas: { smartFormEntries: { total,
// byEntity: { [formId]: n } } }. serverNow: the server's time at the last
// count, which "Mark all as seen" posts back. Empty until the server sends
// counts, which it does only for ACTIVITY_BADGES holders.
// CON-2036: permittedAreas (the areas the user may have notifications for,
// whatever their settings), canPush (holds ACTIVITY_PUSH_NOTIFICATIONS) and
// preferences ({ badge: { area: bool }, push: { area: bool }, muted:
// { area: [ids] } }). A new-activity socket update carries counts only, so
// these are kept until a payload brings them.
const initialState = {
  serverNow: null,
  areas: {},
  permittedAreas: [],
  canPush: false,
  preferences: null,
};

const activityReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ACTIVITY_COUNTS: {
      if (!payload?.areas) return state;
      return produce(state, (draft) => {
        draft.serverNow = payload.serverNow || null;
        draft.areas = payload.areas;
        if (Array.isArray(payload.permittedAreas)) draft.permittedAreas = payload.permittedAreas;
        if (typeof payload.canPush === 'boolean') draft.canPush = payload.canPush;
        if (payload.preferences) draft.preferences = payload.preferences;
      });
    }

    case LOGOUT: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default activityReducer;
